// Handles search/filter functionality within location selection modals
// Location selection uses built-in 'request' controller to POST to backend

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput", "locationList", "locationItem"]

  connect() {
    this.originalItems = [...this.locationItemTargets]
    this.showAllItems()
  }

  search(event) {
    const query = event.target.value.toLowerCase().trim()

    if (query === "") {
      this.showAllItems()
      return
    }

    const matchingItems = this.originalItems.filter(item => {
      const searchTerms = item.dataset.searchTerms.toLowerCase()
      return searchTerms.includes(query)
    })

    // Sort matching items: home first, then vets by distance
    const sortedItems = matchingItems.sort((a, b) => {
      const aType = a.dataset.locationType
      const bType = b.dataset.locationType

      // Home always comes first
      if (aType === 'home' && bType !== 'home') return -1
      if (bType === 'home' && aType !== 'home') return 1

      // For vets, sort by distance
      if (aType === 'vet' && bType === 'vet') {
        const aDistance = parseFloat(a.dataset.locationDistance) || 999
        const bDistance = parseFloat(b.dataset.locationDistance) || 999
        return aDistance - bDistance
      }

      return 0
    })

    this.showFilteredItems(sortedItems)
  }

  showAllItems() {
    // Sort all items: home first, then vets by distance
    const sortedItems = [...this.originalItems].sort((a, b) => {
      const aType = a.dataset.locationType
      const bType = b.dataset.locationType

      // Home always comes first
      if (aType === 'home' && bType !== 'home') return -1
      if (bType === 'home' && aType !== 'home') return 1

      // For vets, sort by distance
      if (aType === 'vet' && bType === 'vet') {
        const aDistance = parseFloat(a.dataset.locationDistance) || 999
        const bDistance = parseFloat(b.dataset.locationDistance) || 999
        return aDistance - bDistance
      }

      return 0
    })

    // Hide all items first
    this.originalItems.forEach(item => {
      item.classList.add('hidden')
    })

    // Show sorted items
    sortedItems.forEach(item => {
      item.classList.remove('hidden')
    })

    // Hide no results message if it exists
    if (this.hasNoResultsTarget) {
      this.noResultsTarget.classList.add('hidden')
    }
  }

  showFilteredItems(matchingItems) {
    // Hide all items first
    this.originalItems.forEach(item => {
      item.classList.add('hidden')
    })

    if (matchingItems.length === 0) {
      // Show no results message if it exists
      if (this.hasNoResultsTarget) {
        this.noResultsTarget.classList.remove('hidden')
      }
    } else {
      // Hide no results message if it exists
      if (this.hasNoResultsTarget) {
        this.noResultsTarget.classList.add('hidden')
      }
      matchingItems.forEach(item => {
        item.classList.remove('hidden')
      })
    }
  }

}
